import { Outlet } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import { SkipLink } from './SkipLink';
import { useT } from '@/i18n';

export function AppLayout() {
  const t = useT();

  return (
    <div className="grain flex min-h-dvh flex-col bg-bg">
      <SkipLink />
      <AppHeader />
      <main
        id="main"
        className="mx-auto w-full max-w-content flex-1 px-4 py-8 sm:px-6 sm:py-12"
      >
        <Outlet />
      </main>

      {/* The sender is the only person this caveat is for. They choose what to
          send and to whom, so they are told plainly what the service does not
          guarantee. Recipients are shown nothing of the sort - it would only
          describe how to keep a copy. */}
      <footer className="border-t border-hairline">
        <p className="mx-auto max-w-content px-4 py-6 text-xs leading-relaxed text-muted sm:px-6">
          {t('brand.footerLimit')}
        </p>
      </footer>
    </div>
  );
}
